import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=83035b1c&scoped=true&"
import script from "./Academy.vue?vue&type=script&lang=js&"
export * from "./Academy.vue?vue&type=script&lang=js&"
import style0 from "./Academy.vue?vue&type=style&index=0&id=83035b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83035b1c",
  null
  
)

export default component.exports